/** @format */

export default {
  bg: {100: "#d9bbef", 200: "#12081f"},
  primary: {100: "#12081f", 200: "#7026b9"},
  secondary: {100: "#8a2387", 200: "#e94057", 300: "#f27121"},
  neutral: {100: "#12081f"},
  text: {100: "#12081f", 200: "#ffffff"},
};
